import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EmptyStateDashboard } from './emptyStateDashboard';
import { DashboardWidgetShell, DashboardWidgetSkeleton } from './widgets';
import { DashboardTabs } from './dashboardTabs';
import { FindLoad } from 'utils';
import { dashboardActions } from 'store';
import { AlertTabEnum, AlertTabs, formatExpiration } from './constants';

const ACTION_TYPE = 'GET_DASHBOARD_CREDENTIAL_ALERTS';

export const CredentialAlertsCard = ({ item, handleDeleteWidget }) => {
    const dispatch = useDispatch();
    const [credTab, setCredTab] = useState(AlertTabEnum.EXPIRING);
    const { credentialAlerts } = useSelector((state) => ({
        credentialAlerts: state.dashboard.credentialAlerts,
    }));
    const loader = FindLoad(ACTION_TYPE);
    const activeList = credTab === AlertTabEnum.EXPIRING ? credentialAlerts?.expiring : credentialAlerts?.expired;
    const tabs = AlertTabs.map((tab) => ({
        ...tab,
        count: (tab.key === AlertTabEnum.EXPIRING ? credentialAlerts?.expiring?.length : credentialAlerts?.expired?.length) || 0,
    }));

    useEffect(() => {
        if (item?.apiPath) {
            dispatch(dashboardActions.getWidgetsData(ACTION_TYPE, item?.apiPath));
        }
    }, [item?.apiPath]);

    if (loader?.length) {
        return <DashboardWidgetSkeleton />;
    }

    return (
        <DashboardWidgetShell iconId={3} onClose={handleDeleteWidget}>
            <div className="dashboard-tabbed-body">
                <DashboardTabs activeKey={credTab} onChange={setCredTab} tabs={tabs} />

                <div className="main-dashboard-card-body">
                    {activeList?.length ? (
                        <div className={`dashboard-alert-list ${credTab === AlertTabEnum.EXPIRED ? 'is-expired' : ''}`}>
                            {activeList.map((cred, index) => (
                                <div className="dashboard-alert-row" key={index}>
                                    <div className="dashboard-alert-row__body">
                                        {cred?.staffName && <p className="dashboard-alert-row__name">{cred?.staffName}</p>}
                                        <p className="dashboard-alert-row__sub">
                                            {cred?.title && <span className="dashboard-alert-row__type">{cred?.title}</span>}
                                            <span className="dashboard-alert-row__exp">
                                                {cred?.title ? ' - ' : ''}
                                                {formatExpiration(cred)}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <EmptyStateDashboard
                            iconId={3}
                            title={credTab === AlertTabEnum.EXPIRING ? 'No expiring credentials' : 'No expired credentials'}
                            description={
                                credTab === AlertTabEnum.EXPIRING ? (
                                    <p>
                                        All credentials are up to date. <br /> Nothing is due to expire soon.
                                    </p>
                                ) : (
                                    <p>
                                        All credentials are up to date. <br /> Continue tracking to stay compliant.
                                    </p>
                                )
                            }
                        />
                    )}
                </div>
            </div>
        </DashboardWidgetShell>
    );
};
